module.exports = __webpack_public_path__ + "img/3.e950ed81.jpg";